import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Team } from '../types/index';

export const useSeriesFromURL = (availableTeams: Team[]) => {
  const { teamId } = useParams<{ teamId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [validatedTeam, setValidatedTeam] = useState<Team | null>(null);
  const [shouldClearTeam, setShouldClearTeam] = useState(false);

  useEffect(() => {
    if (teamId && availableTeams.length > 0) {
      const team = availableTeams.find(t => t.teamId === teamId);
      
      if (team) {
        // Valid teamId - update state and localStorage
        setValidatedTeam(team);
        localStorage.setItem('selectedTeamId', teamId);
        setShouldClearTeam(false);
      } else {
        // Invalid teamId - flag for clearing and redirect
        setValidatedTeam(null);
        setShouldClearTeam(true);
        navigate('/scheduled-topics', { replace: true });
      }
    } else if (!teamId && !shouldClearTeam) {
      // No teamId in URL - only load from localStorage if NOT at root
      if (location.pathname !== '/') {
        const savedTeamId = localStorage.getItem('selectedTeamId');
        if (savedTeamId && availableTeams.length > 0) {
          const savedTeam = availableTeams.find(t => t.teamId === savedTeamId);
          if (savedTeam) {
            setValidatedTeam(savedTeam);
          }
        }
      }
    }
  }, [teamId, availableTeams, navigate, shouldClearTeam, location.pathname]);

  return { teamId, validatedTeam, shouldClearTeam };
};
